<template>
  <generic-modal
    v-bind="$attrs"
    :value="value"
    confirm-color="error"
    confirm-text="Reset Changes"
    title="Reset Changes"
    persistent
    v-on="$listeners"
  >
    This will reset your {{ category }} to its original state. <strong>All changes will be lost</strong>
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/modals/generic-modal'

export default {
  name: 'ResetModal',
  components: {
    GenericModal,
  },
  props: {
    category: {
      type: String,
      default: 'options',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
